/* eslint-disable no-console */
import { ISelectOption, Select } from '@aon/aon-tws-common-ui';
import React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../../contentConstants';

const FollowupQuestionDimensionOptions = styled(Select)`
	width: 100%;
`;
export interface IFollowUpQuestionResponseOptions {
	dimensionOptions: ISelectOption[];
	selectedValues: string[];
	applyDimension: (values?: string | string[], options?: ISelectOption[]) => void;
}
export default function FollowUpQuestionResponseOptions(props: IFollowUpQuestionResponseOptions) {
	return (
		<FollowupQuestionDimensionOptions
			className='followupQuestionOption'
			items={props.dimensionOptions}
			selectedValues={props.selectedValues}
			onApply={props.applyDimension}
			hasGroups={false}
			multiple={true}
			showCount={true}
			showSearch={true}
			size='sm'
			dropdownSize='lg'
			displayText='Select Dimensions'
			error={props.dimensionOptions.length === 0}
			message={ContentConstants.FOLLOWUP_QUESTION_NO_SURVEY_DIMENSION}
			disabled={props.dimensionOptions.length === 0}
		/>
	);
}
